<script>
  import config from "./../config.js";
  import { user } from './stores.js';
  import { onMount } from 'svelte';
  import Alerts from './components/Alerts.svelte';
  
  import Drawer from './components/Drawer.svelte';
  import Widget from './components/Widget.svelte';
  
  import Plot from './components/plot/Plot.svelte';
  
  let zero1 = 660418;
  let zero2 = 542270;
  
  const graphs = [
    {
      name: "Bucket 1",
      key: "depth bucket-1",
      mode: 'markers',
      shape: 'line',
      opacity: 1,
      type: 'scatter',
      legend: "L",
      side: "left", 
      color: "#EE4266", 
      width: 1,
      transformY: (y) => { return (y.map((v) => { return (parseFloat(v, 10) - zero1) / 1446148; })); },
      hovertemplate: '%{y:.2f}'
    },
/*     {
      name: "Average",
      key: "depth bucket-1",
      mode: 'line',
      smoothing: 0.9,
      type: 'scatter',
      legend: "ml",
      side: "left",
      color: "#EE4266",
      width: 2,
      transformY: (y) => { return (y.map((v) => { return (parseFloat(v, 10) - zero1) / 202; })); }
    }, */
    {name: "Battery 1 *", key: "volt bucket-1", legend: "volts", side: "right", color: "#FFD23F", width: 1, xaxis: "x2", yaxis: "y2"},
    {name: "Temperature", key: "temperature laitdepoule", legend: "celcius", side: "right", color: "#ddd", width: 1, yaxis: "y3"},
    {
      name: "Bucket 2",
      key: "depth bucket-2",
      mode: 'markers',
      shape: 'spline',
      opacity: 0.5,
      type: 'scatter',
      legend: "ml",
      side: "left", 
      color: "#31b9a3", 
      width: 1,
      hovertemplate: '%{y:.2f}',
      transformY: (y) => { return (y.map((v) => { return (parseFloat(v, 10) - zero2) / 202; })); }
    },
/*       {
      name: "Average",
      key: "depth bucket-2",
      mode: 'line',
      smoothing: 0.9,
      type: 'scatter',
      legend: "ml",
      side: "left",
      color: "#31b9a3",
      width: 2,
      transformY: (y) => { return (y.map((v) => { return (parseFloat(v, 10) - zero1) / 202; })); }
    }, */
    {name: "Battery 2 *", key: "volt bucket-2", legend: "volts", side: "right", color: "#000", width: 1, xaxis: "x2", yaxis: "y2"},
  ];
  
  const isMobile = window.screen.width < 600;
  
  const layout = {
    grid: {rows: isMobile ? 2 : 1, pattern: 'independent'},
    showlegend: true,
    legend: {
      y: -0.25,
      orientation: "h"
    },
    yaxis: {
      title: "L",
      titlefont: { color: "#FF6B6B" },
      tickfont: { color: "#FF6B6B" },
      domain: [0, isMobile ? 0.70 : 1]
    },
    yaxis2: {
      title: "volts",
      titlefont: { color: "#FFD23F" },
      tickfont: { color: "#FFD23F" },
      anchor: "x2",
      range: [2, 6],
      domain: [isMobile ? 0.80 : 0, 1]
    },
    yaxis3: {
      title: "celcius",
      zeroline: false,
      titlefont: { color: "#ddd" },
      tickfont: { color: "#ddd" },
      overlaying: "y",
      side: "right"
    },
    xaxis: {
      domain: [0, isMobile ? 1 : 0.75],
      showticklabels: isMobile ? false : true,
    },
    xaxis2: {
      domain: [isMobile ? 0 : 0.85, 1],
      showticklabels: isMobile ? false : true,
    },
    shapes: !isMobile ? [
      {
          type: 'line',
          xref: 'paper',
          yref: 'paper',
          x0: 0.85,
          y0: 0.32,
          x1: 1,
          y1: 0.32,
          line:{
              color: '#EE4266',
              width: 1,
              dash:'dot'
          }
      }
    ] : []
  };
  
  </script>
  
  <style>
  </style>
  
  <Drawer />
  <Alerts />
  
  <div class="container">
    <Widget />
  
    <Plot graphs={graphs} layout={layout} />
  
    <p><em><strong>Click once</strong> on legend to <strong>remove</strong> a trace. <strong>Double click</strong> on legend to <strong>isolate</strong> a trace.</em></p>
    <p>
      <em>
    * Lipoly batteries are 'maxed out' at 4.2V and stick around 3.7V for much of the battery life, then slowly sink down to 3.2V or so before the protection circuitry cuts it off.
      </em>
    </p>
  </div>
  